<!-- eslint-disable @typescript-eslint/no-unused-vars -->
<template>
  <div
    v-if="rentalUnitSelected && rentalUnitSelected.Prices"
    class="d-flex justify-space-between w-100 flex-column"
  >
    <div class="booking-content">
      <div class="ion-padding-bottom d-flex w-100 align-center">
        <slot name="prepend" />

        <p class="font-md bold-medium blue-darker pl-xs">{{ t('booking.verify.title') }}</p>
      </div>
      <p class="subtitle grey ion-padding-bottom">
        {{ t('booking.verify.description') }}
      </p>

      <img
        class="booking-image border-default"
        :src="
          getCoverImage(
            rentalUnitSelected.Images.length > 0
              ? rentalUnitSelected.Images
              : (rentalUnitSelected.Property?.Images as Photos[]),
          )
        "
      />

      <p class="font-md bold-medium blue-darker ion-padding-bottom d-flex w-100">
        {{ getCurrentName(rentalUnitSelected, languageSelected) }}
      </p>

      <EditBookingDates />

      <!-- <ion-accordion-group v-model="accordion" class="py-xs" ref="accordionGroup">
        <ion-accordion value="ticket">
          <ion-item slot="header" color="light">
            <div>
              <p class="subtitle grey">{{ t('booking.verify.costSummary') }}</p>
              <p class="title" v-if="accordion !== 'ticket'">
                {{ amountMask(getTotal, rentalUnitSelected.Prices[0].currency as string) }}
              </p>
            </div>
          </ion-item>
          <div
            v-if="
              rentalUnitSelected.Prices[0].reservationAmount ||
              rentalUnitSelected.Prices[0].depositAmount
            "
            class="ion-padding bg-white"
            slot="content"
          >
            <p class="subtitle grey">{{ t('booking.verify.upfront') }}</p>
            <div
              v-if="
                rentalUnitSelected.Prices[0].reservationAmount &&
                rentalUnitSelected.Prices[0].reservationAmount !== 0
              "
              class="d-flex align-center justify-space-between w-100 price-subtitle"
            >
              <p class="subtitle grey bold-medium">{{ t('booking.verify.reservationValue') }}</p>
              <p class="subtitle bold-medium">
                {{
                  amountMask(
                    Number(rentalUnitSelected.Prices[0].reservationAmount),
                    rentalUnitSelected.Prices[0].currency as string,
                  )
                }}
              </p>
            </div>

            <div
              v-if="
                rentalUnitSelected.Prices[0].depositAmount &&
                rentalUnitSelected.Prices[0].depositAmount !== 0
              "
              class="d-flex align-center justify-space-between w-100 price-subtitle"
            >
              <p class="subtitle grey bold-medium">{{ t('booking.verify.deposit') }}</p>
              <p class="subtitle bold-medium">
                {{
                  amountMask(
                    Number(rentalUnitSelected.Prices[0].depositAmount),
                    rentalUnitSelected.Prices[0].currency as string,
                  )
                }}
              </p>
            </div>
          </div>

          <div class="ion-padding bg-white" slot="content">
            <p class="subtitle grey">{{ t('booking.verify.fixed') }}</p>
            <div class="d-flex align-center justify-space-between w-100 price-subtitle">
              <p class="subtitle grey bold-medium">{{ t('booking.verify.rent') }}</p>
              <p class="subtitle bold-medium">
                {{
                  amountMask(
                    Number(rentalUnitSelected.Prices[0].amount),
                    rentalUnitSelected.Prices[0].currency as string,
                  )
                }}
              </p>
            </div>

            <div
              v-for="cost in getAdditionalCosts()"
              :key="`additional-${cost.id}`"
              class="d-flex align-center justify-space-between w-100 price-subtitle"
            >
              <p class="subtitle grey bold-medium">{{ cost.title }}</p>
              <p class="subtitle bold-medium">
                {{ amountMask(cost.amount, rentalUnitSelected.Prices[0].currency as string) }}
              </p>
            </div>
          </div>

          <div v-if="taxes.length > 0" class="ion-padding bg-white" slot="content">
            <p class="subtitle grey">{{ t('booking.verify.taxes') }}</p>

            <div
              v-for="(tax, idx) in taxes"
              :key="`tax-${idx}`"
              class="d-flex align-center justify-space-between w-100 price-subtitle"
            >
              <p class="subtitle grey bold-medium">
                {{ tax.type !== 'OTHER' ? tax.type : tax.name }} ({{ tax.value }}%)
              </p>
              <p class="subtitle bold-medium">
                {{
                  amountMask(
                    getNetTotal * (tax.value / 100),
                    rentalUnitSelected.Prices[0].currency as string,
                  )
                }}
              </p>
            </div>
          </div>
        </ion-accordion>
      </ion-accordion-group> -->
    </div>

    <div>
      <div
        v-if="accordion === 'ticket'"
        class="d-flex align-center justify-space-between w-100 pa-xs"
      >
        <p class="subtitle grey bold-medium">{{ t('invoices.total') }}</p>
        <p class="title" v-if="rentalUnitSelected">
          {{ amountMask(getTotal, rentalUnitSelected.Prices[0].currency as string) }}
        </p>
      </div>
    </div>

    <div class="d-flex justify-space-between mt-xs w-100">
      <ion-button
        fill="clear"
        expand="block"
        size="default"
        color="primary"
        class="text-lg text-weight-bold"
        @click="$emit('back')"
      >
        {{ t('global.back') }}
        <ion-icon slot="start" :icon="chevronBackOutline" aria-hidden="true"></ion-icon>
      </ion-button>

      <ion-button
        :disabled="
          !selectedFilters.mappedFilters.startAvailabilityDate ||
          !selectedFilters.mappedFilters.endAvailabilityDate
        "
        fill="solid"
        expand="block"
        size="default"
        color="primary"
        class="text-lg text-weight-bold"
        @click="confirmBooking()"
      >
        {{ t('booking.verify.confirm') }}
      </ion-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useI18n } from 'vue-i18n';
  import { IonButton, IonIcon } from '@ionic/vue';
  import { Photos } from '@/interfaces/elastic/elastic.interface';
  import { ref } from 'vue';
  import router from '@/router';
  import { useSearch } from '@/composables/useSearch';
  import { storeToRefs } from 'pinia';
  import { useElasticStore } from '@/stores/elastic-store';
  import { useBookingStore } from '@/stores/booking-store';
  import { useToast } from '@/composables/useToast';
  import { useBooking } from '@/composables/useBooking';
  import { amountMask } from '@/utils/validations/formats';
  import EditBookingDates from './EditBookingDates.vue';
  import { chevronBackOutline } from 'ionicons/icons';
  import { useProfileStore } from '@/stores/profile-store';

  const { getCoverImage, getCurrentName } = useSearch();
  const { selectedFilters } = storeToRefs(useElasticStore());
  const { bookingForm, rentalUnitSelected, isLoading, additionalList } =
    storeToRefs(useBookingStore());
  const { createBooking } = useBookingStore();
  const { getTotal } = useBooking();
  const { languageSelected } = storeToRefs(useProfileStore());

  const { t } = useI18n();
  const accordion = ref('');
  const { showToast } = useToast();

  const emit = defineEmits(['close', 'back']);

  const handleCreateBooking = async () => {
    try {
      isLoading.value = true;
      if (rentalUnitSelected.value) {
        const price =
          rentalUnitSelected.value.Prices && rentalUnitSelected.value.Prices[0]
            ? rentalUnitSelected.value.Prices[0]
            : {
                amount: 0,
                contractType: 'monthly',
                currency: 'EUR',
                depositAmount: 0,
                discountPercent: 0,
                maxPeriod: null,
                minPeriod: 30,
                paymentCycle: 'monthly',
                reservationAmount: 0,
              };

        bookingForm.value = {
          RentalUnitId: rentalUnitSelected.value.id,
          startDate: selectedFilters.value.mappedFilters.startAvailabilityDate as string,
          endDate: selectedFilters.value.mappedFilters.endAvailabilityDate as string,
          contractType: price.contractType,
          currency: price.currency,
          amount: price.amount,
          depositAmount: price.depositAmount,
          reservationAmount: price.reservationAmount,
          paymentCycle: price.paymentCycle,
          additionalCosts: additionalList.value.filter((obj) => obj.isChecked),
        };
      }

      const response = await createBooking();
      if (response.success) {
        emit('close');

        await showToast(response.msg as string);

        await router.replace({
          name: 'MyStay',
        });
        window.location.reload();
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    } finally {
      isLoading.value = false;
    }
  };

  const confirmBooking = () => {
    handleCreateBooking();
  };
</script>

<style lang="css" scoped>
  .justify-space-between {
    justify-content: space-between;
  }

  .booking-image {
    height: 180px !important;
    width: 100% !important;
    object-fit: cover;
  }

  .booking-content {
    height: 460px;
    overflow: auto;
  }

  .booking-dates-title {
    white-space: nowrap;
    width: 180px;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
</style>
